const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/slack/callback.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/slack/callback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const slackCallbackSchema = z.object({
  slack: z.enum(['installed', 'already_connected', 'error']).optional()
});
export const Route = createFileRoute('/(app)/integrations/slack/callback')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(slackCallbackSchema),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});